import React, { FC, ReactElement } from "react"
import styled from "@emotion/styled"
import { useScreenClass, Container, Row, Col } from "react-grid-system"
import { SectionTitle } from "./Content"
import { mobileFirstDevice } from "@/utils/media-queries"

interface TitleProps {
  align?: string
  light?: boolean
}

const Title = styled(SectionTitle, {
  shouldForwardProp: prop => prop !== "light" && prop !== "align",
})<TitleProps>`
  padding-bottom: 60px;
  line-height: 125%;
  text-align: ${({ align }) => align || "left"};
  ${({ light, theme }) => (light ? `color: ${theme.colors.black}` : "")};

  @media ${mobileFirstDevice.tablet} {
    padding-bottom: 30px;
  }

  @media ${mobileFirstDevice.laptop} {
    padding-bottom: 80px;
  }
`

const SectionContainer = styled(Container)`
  margin-bottom: 56px;

  @media ${mobileFirstDevice.tablet} {
    padding: 0 !important;
  }
`

interface Props {
  id?: string
  children: ReactElement | ReactElement[]
  title?: string
  alignTitle?: string
  light?: boolean
  TitleComponent?: React.JSXElementConstructor<any>
  className?: string
  maxWidth?: string
  justifyContent?: string
}

const leftAlignSizes = ["md", "lg"]

const Section: FC<Props> = ({
  id,
  children,
  title,
  alignTitle,
  light = false,
  TitleComponent,
  className,
  maxWidth = "100%",
  justifyContent = "flex-start",
}) => {
  const screenClass = useScreenClass()
  const defaultAlign = leftAlignSizes.includes(screenClass) ? "left" : "center"
  return (
    <SectionContainer id={id} fluid xs sm className={className}>
      <Row style={{ justifyContent }} gutterWidth={0}>
        <Col style={{ maxWidth }} xs={12}>
          {TitleComponent ? (
            <TitleComponent />
          ) : title ? (
            <Title light={light} align={alignTitle || defaultAlign}>
              {title}
            </Title>
          ) : undefined}
        </Col>
        <Col xs={12}>{children}</Col>
      </Row>
    </SectionContainer>
  )
}

export default Section
